import { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { useQueryClient } from '@tanstack/react-query'

import { notify } from 'Actions/notifications'
import CaarlForm from '@components/forms/CaarlForm'
import { useCaarlConnectionLink, getOrRefetchCaarlConnectionLink } from '@hooks/queries/caarl'
import { setCurrentUser } from '../../../actions/user'
import axiosClient from '../../../api/axios-client'

const AssistanceJuridiquePage = ({ dispatch, currentUser }) => {
  const queryClient = useQueryClient()
  const [isSubscribePending, setIsSubscribePending] = useState(false)
  const isAlreadySubscribed = !!currentUser.caarl_subscription

  // fetch connection link as soon as page renders, so that when we call getOrRefetchCaarlConnectionLink in onClick,
  // the link is already cached and we avoid the api request if staleTime is not expired yet
  const caarlLinkQuery = useCaarlConnectionLink(currentUser.id, {
    enabled: isAlreadySubscribed && !!currentUser.id,
  })

  const isFetchLinkPending = isAlreadySubscribed ? caarlLinkQuery.isPending : false

  const onClick = useCallback(async () => {
    if (isAlreadySubscribed) {
      const { connectionLink } = await getOrRefetchCaarlConnectionLink(queryClient, currentUser.id)
      window.open(connectionLink, '_blank', 'noopener,noreferrer')
    } else {
      setIsSubscribePending(true)
      try {
        const res = await axiosClient.post('/api/caarl/subscribe')

        dispatch(setCurrentUser(res.data.user))
        dispatch(notify('success', 'Votre accès à l\'assistance juridique a bien été activé.'))
      } catch (error) {
        dispatch(notify('error', 'Une erreur est survenue, votre demande n\'a pu être prise en compte, merci de réessayer ultérieurement ou de contacter notre service clients.'))
      } finally {
        setIsSubscribePending(false)
      }
    }
  }, [isAlreadySubscribed, currentUser, dispatch, queryClient])

  return (
    <div className="max-w-[600px] mt-4 mx-auto">
      <CaarlForm
        singleButton
        setSelected={onClick}
        isAlreadySubscribed={isAlreadySubscribed}
        isButtonLoading={isFetchLinkPending || isSubscribePending}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(mapStateToProps)(AssistanceJuridiquePage)